'use strict';

/**
 * MainController - contrôleur principal du layout
 */
import appModule from '../app.module';

angular.module(appModule)
.controller('MainController', ['$scope', '$translate', 'Auth', '$window', '$document', function($scope, $translate, Auth, $window, $document) {
  
  $scope.currentLanguage = $translate.use() || 'fr';
  $scope.currentYear = new Date().getFullYear();
  
  // Initialiser le mode clair/sombre
  $scope.isDarkMode = $window.localStorage.getItem('darkMode') === 'true';
  
  // Fonction pour basculer entre mode clair et sombre
  $scope.toggleDarkMode = function() {
    $scope.isDarkMode = !$scope.isDarkMode;
    $window.localStorage.setItem('darkMode', $scope.isDarkMode);
  };
  
  // Fonction pour changer de langue
  $scope.changeLanguage = function(langKey) {
    $translate.use(langKey);
    $scope.currentLanguage = langKey;
  };
  
  // Exposer les fonctions d'authentification directement au $scope
  $scope.isAuthenticated = function() {
    return Auth.isAuthenticated();
  };
  
  $scope.hasAuthority = function(authority) {
    return Auth.hasAuthority(authority);
  };
  
  $scope.hasAnyAuthority = function(authorities) {
    return Auth.hasAnyAuthority(authorities);
  };
  
  // Récupérer les informations de l'utilisateur si authentifié
  Auth.identity().then(function(user) {
    $scope.user = user;
  }).catch(function(error) {
    console.error('Erreur lors de la récupération des informations utilisateur:', error);
  });
  
  // Fonction pour gérer le header sticky - version simplifiée
  function initStickyHeader() {
    var header = document.querySelector('.main-header');
    if (!header) {
      console.error('Header element not found');
      return;
    }
    
    // Créer un wrapper pour le header si nécessaire
    var headerHeight = header.offsetHeight;
    var wrapper = document.createElement('div');
    wrapper.className = 'sticky-wrapper';
    
    // Insérer le wrapper avant le header et y déplacer le header
    if (header.parentNode) {
      header.parentNode.insertBefore(wrapper, header);
      wrapper.appendChild(header);
      wrapper.style.height = headerHeight + 'px';
    }
    
    function handleScroll() {
      var scrollPosition = window.scrollY || window.pageYOffset;
      
      // À partir d'une certaine position de défilement, on rend le header sticky
      if (scrollPosition > headerHeight) {
        header.classList.add('sticky');
        wrapper.style.height = headerHeight + 'px'; // Maintenir la hauteur du wrapper
      } else {
        header.classList.remove('sticky');
      }
    }
    
    // Attacher l'événement au défilement
    window.addEventListener('scroll', handleScroll);
    
    // Exécuter une fois au chargement
    handleScroll();
    
    // Nettoyage lors de la destruction du scope
    $scope.$on('$destroy', function() {
      window.removeEventListener('scroll', handleScroll);
    });
  }
  
  // Initialiser le header sticky après le chargement complet du DOM
  angular.element(document).ready(function() {
    initStickyHeader();
  });
  
  // Fonction de déconnexion
  $scope.logout = function() {
    Auth.logout();
    $scope.user = null;
  };
}]);
